<template>
  <div>
    <h1 class="title">Lista de Tickets</h1>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>Titulo</th>
          <th>Fecha</th>
          <th v-if="isinicial">Empresa</th>
          <th>Proyecto</th>
          <th>Descripción</th>
          <th>Status</th>
          <th>Adjuntos</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in tickets" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            {{ item.title }} <br />
            <small style="font-size: 12px" class="has-text-grey"
              >Creado por : {{ item.usermg.displayName }}</small
            >
          </td>
          <td>{{ item.created | dateletra() }}</td>
          <td v-if="isinicial">{{ item.empresa.nombre }}</td>
          <td>{{ item.project.name }}</td>
          <td>{{ item.descripcion }}</td>
          <td>{{ item.status }}</td>
          <td>
            <small v-for="(item1, index1) in item.attach" :key="index1">
              {{ index1 !== 0 ? "|" : ""
              }}<a :href="item1.url" target="blank">{{ item1.name }}</a>
            </small>
          </td>
          <td>
            <div class="buttons">
              <!-- <button class="button is-small is-dark">
                <span class="icon is-small">
                  <span class="material-icons"> zoom_in </span>
                </span>
                <span>Detalle</span>
              </button> -->
              <button class="button is-small is-link" @click="editTicket(item)">
                <span class="icon is-small">
                  <span class="material-icons"> edit </span>
                </span>
                <span>Editar</span>
              </button>
              <!-- <button class="button is-small is-danger">
                <span class="icon is-small">
                  <span class="material-icons"> delete_forever </span>
                </span>
                <span>Borrar</span>
              </button> -->
              <button
                v-if="isinicial"
                class="button is-small is-primary"
                @click="newTask(item)"
              >
                <span class="icon is-small">
                  <span class="material-icons"> add </span>
                </span>
                <span>Crear Tarea</span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <y-modalticket
      :showmodal="showmodal"
      :tags="todoslostags"
      :modaldata="task"
      :tickets="tickets"
      @closemodal="showmodal = false"
      @savemodal="savemodal"
    ></y-modalticket>
  </div>
</template>

<script>
import yModalticket from "@/components/modals/Modalticket.vue";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      todoslostags: [],
      showmodal: false,
      tickets: [],
      task: {
        orden: null,
        _id: null,
        date: null,
        title: null,
        descripcion: null,
        status: "Pendiente",
        tags: [],
        priority: "Baja",
        dateResolve: null,
        assignedto: null,
        ticket: null,
        empresa: null,
        project: null,
        attach: [],
      },
    };
  },
  computed: {
    isinicial() {
      // si la ruta es la del admin
      let returned;
      returned = this.$route.name.toString() === "task.ticketlist";
      return returned;
    },
  },
  methods: {
    async savemodal(payload) {
      try {
        console.log("click", payload);
        const result = await apiServices.post(`/savetask`, payload);
        if (result.data) {
          this.showmodal = false;
          this.$store.dispatch("notify", {
            message: "Tarea guardada con éxito .",
            type: "is-primary",
            position: "top-center",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    newTask(item) {
      this.task = {
        orden: null,
        _id: null,
        date: null,
        title: null,
        descripcion: null,
        status: "Pendiente",
        tags: [],
        priority: "Baja",
        dateResolve: null,
        assignedto: null,
        ticket: item._id,
        empresa: item.empresa,
        project: item.project,
        attach: [],
      };
      this.showmodal = true;
    },
    editTicket(item) {
      this.$router.push({
        name: "tickets.edit",
        params: { id: item._id },
      });
    },
    async findTickets() {
      try {
        let result;
        if (this.isinicial) {
          result = await apiServices.get(`/getalltickets`);
        } else {
          result = await apiServices.get(`/gettickets`);
        }
        if (result.data) {
          this.tickets = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findTickets();
  },
  components: {
    yModalticket,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/proyectos/tickets/ListTicket.vue